import { uploadData, getUrl } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';

class S3ImageService {
  async uploadPosterImage(file, movieId = null) {
    try {
      const fileExtension = file.name.split('.').pop();
      const fileName = `posters/${movieId || uuidv4()}.${fileExtension}`;
      
      const result = await uploadData({
        key: fileName,
        data: file,
        options: {
          accessLevel: 'guest', // Public access
          contentType: file.type
        }
      });

      // Return direct public S3 URL without authentication
      const publicUrl = `https://devbucket96ac4-prod.s3.ap-south-1.amazonaws.com/public/${fileName}`;

      return {
        success: true,
        key: fileName,
        url: publicUrl,
        result
      };
    } catch (error) {
      console.error('Error uploading poster:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  async uploadBackdropImage(file, movieId = null) {
    try {
      const fileExtension = file.name.split('.').pop();
      const fileName = `backdrops/${movieId || uuidv4()}.${fileExtension}`;
      
      const result = await uploadData({
        key: fileName,
        data: file,
        options: {
          accessLevel: 'guest',
          contentType: file.type,
          metadata: {
            movieId: movieId || 'new',
            uploadedAt: new Date().toISOString()
          }
        }
      });

      // Return direct public S3 URL without authentication
      const publicUrl = `https://devbucket96ac4-prod.s3.ap-south-1.amazonaws.com/public/${fileName}`;

      return {
        success: true,
        key: fileName,
        url: publicUrl,
        result
      };
    } catch (error) {
      console.error('Error uploading backdrop:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  async getImageUrl(key) {
    try {
      // Return direct public S3 URL without authentication
      return `https://devbucket96ac4-prod.s3.ap-south-1.amazonaws.com/public/${key}`;
    } catch (error) {
      console.error('Error getting image URL:', error);
      return null;
    }
  }
}

export const s3ImageService = new S3ImageService();